const API_STRATEGY: "engage" | "mm" | "cop" = "mm"; //TODO: Get strategy through bus or global.
import { MMFetchPartnerURL } from "./getPartner";
import { MMFetchUserURL, getMmUser } from "./getUser";
import { type MmUserPartial } from "./types";

export type Token = {
  token: string;
  parsedToken: {
    sub?: string;
  };
};

type WithToken<T> = (token: string) => Promise<T>;

type ApiStrategy = {
  urls: {
    userUrl: string;
    partnerUrl: string;
  };
  getUser: WithToken<MmUserPartial>;
};

const apiStrategies: Record<typeof API_STRATEGY, ApiStrategy> = {
  mm: {
    urls: {
      userUrl: MMFetchUserURL,
      partnerUrl: MMFetchPartnerURL,
    },
    getUser: getMmUser,
  },
};

export const apiUrls = apiStrategies[API_STRATEGY].urls;
export const getUser = apiStrategies[API_STRATEGY].getUser;
export { getFeatures, getName } from "./getUser";
